<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <!-- new right start-->
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :append="[this.editData.custom_name]"/>
          <div class="table-agile-info">
            <!-- 星图系统tab -->
            <div class="edit-bg-wrap">
              <div class="basic-information"><!-- 虚线验证在form 加 error-form ref="editDataForm":rules="rules"-->
                <el-form
                  :model="editData"
                  class="error-form basic-table basic-table-div"
                >
                  <el-collapse v-model="activeNames">
                    <el-collapse-item
                      title="基本信息"
                      name="1">
                      <el-row>
                        <el-col :span="1">姓名</el-col>
                        <el-col :span="5">
                          <el-input
                            v-model="editData['custom_name']"
                            class="jm-input-common4"
                            autofocus="autofocus"/>
                        </el-col>
                        <el-col :span="1">昵称</el-col>
                        <el-col :span="5">
                          <el-input
                            v-model="editData['custom_nickname_tell']"
                            class="jm-input-common4"/>
                        </el-col>
                        <el-col :span="1">采集功能</el-col>
                        <el-col
                          :span="5">
                          <el-select
                            filterable
                            v-model="editData['create_point']"
                            class="jm-input-common4"
                            clearable
                            placeholder="请选择">
                            <template v-for="item in ds.create_point">
                              <el-option
                                v-if="item.adminView === 1 || $hasPermission([52])"
                                :key="item.userid"
                                :label="item.username"
                                :value="item.userid"/>
                            </template>
                          </el-select>
                        </el-col>
                        <el-col :span="1">推广人</el-col>
                        <el-col
                          :span="5">
                          <el-select
                            filterable
                            v-model="editData['custom_promoter']"
                            class="jm-input-common4"
                            clearable
                            placeholder="请选择">
                            <el-option-group
                              v-for="(group, k) in ds.create_person"
                              :key="k"
                              :label="k">
                              <el-option
                                v-for="item in group"
                                :key="item.userid"
                                :label="item.username"
                                :value="item.userid"/>
                            </el-option-group>
                          </el-select>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1">电话</el-col>
                        <el-col :span="5">
                          <el-form-item prop="crm_tel">
                            <el-input
                              ref="telInput"
                              v-model.trim="editData['crm_tel']"
                            >
                              <template slot="prepend">0086-</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1">归属地区</el-col>
                        <el-col :span="5">
                          <el-form-item>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1">QQ</el-col>
                        <el-col :span="5">
                          <el-form-item prop="crm_qq">
                            <el-input
                              v-model.trim="editData['crm_qq']"
                              :maxlength="20"
                              class="jm-input-common4"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1">微信</el-col>
                        <el-col :span="5">
                          <el-form-item prop="crm_weixin">
                            <el-input
                              v-model.trim="editData['crm_weixin']"
                              class="jm-input-common4"/>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1">渠道来源</el-col>
                        <el-col
                          :span="11"
                          class="custom_from">
                          <jm-channel
                            v-model="channels"
                            :is-all="false"
                            :final.sync="channelFinal"
                            clearable
                            ref="channelRef"
                            filterable/>
                        </el-col>
                        <el-col :span="1">咨询老师</el-col>
                        <el-col
                          :span="5">
                          <el-select
                            v-model="editData.crm_sayer"
                            class="jm-input-common4"
                            placeholder="请选择"
                            filterable
                          >
                            <el-option label="自动分配" :value="-1"></el-option>
                            <el-option-group v-for="(group, k) in teachers['advisory_teacher']" :key="k" :label="k">
                              <el-option
                                v-for="item in group"
                                :key="item.userid"
                                :label="item.truename"
                                :value="item.userid"
                              ></el-option>
                            </el-option-group>
                          </el-select>
                        </el-col>
                        <el-col :span="1">参与活动</el-col>
                        <el-col
                          :span="5">
                          <el-select
                            class="jm-input-common4"
                            placeholder="请选择"
                            v-model="editData['activity_id']"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="item in activityList"
                              :key="item.id"
                              :label="item.act_title"
                              :value="item.id"/>
                          </el-select>
                        </el-col>
                      </el-row>
                      <el-row class="hope_country">
                        <el-col style="justify-content: flex-end; padding-right: 5px; font-weight: bold; font-size: 14px; padding-left: 0">意向国家</el-col>
                        <el-col style="flex-wrap: wrap" :class="countryCheckboxLock[0] && editData['custom_hope_country'].length > 0 ? 'col-border-light' : ''">
                          <el-checkbox-group v-model="editData['custom_hope_country']" v-show="countryCheckboxLock[0] === false && editData['custom_hope_country'].length > 0">
                            <el-checkbox
                              v-for="item in hopeCountries"
                              v-show="editData['custom_hope_country'].indexOf(item.id) > -1"
                              :label="item.id"
                              :key="item.id"
                              :disabled="!isNew && isDisabledCountry(item.id)">{{ item.value }}</el-checkbox>
                          </el-checkbox-group>
                          <el-checkbox-group v-model="editData['custom_hope_country']" v-show="countryCheckboxLock[0] === true || editData['custom_hope_country'].length < 1">
                            <el-checkbox
                              v-for="item in hopeCountries"
                              :label="item.id"
                              :key="item.id"
                              :disabled="!isNew && isDisabledCountry(item.id)">{{ item.value }}</el-checkbox>
                          </el-checkbox-group>
                          <div style="width: 100%; padding-bottom: 10px" v-show="editData['custom_hope_country'].length > 0">
                            <el-button
                              class="country-button"
                              type="primary"
                              size="medium"
                              @click="countryCheckboxClick(1)">{{ countryCheckboxLock[0] ? '收起国家' : '更多国家' }}</el-button>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row v-if="this.editData.custom_hope_country.indexOf(2061)!==-1">
                        <el-col :span="1">说明</el-col>
                        <el-col :span="23">
                          <el-select
                            clearable
                            class="jm-input-common4"
                            v-model="editData['singapore_explain']"
                            placeholder="请选择">
                            <el-option
                              v-for="item in singapore_explain"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <span class="colour" style="margin-left: 8px">*(意向国家为新加坡时必填)</span>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1" style="height: 160px">备注</el-col>
                        <el-col :span="23">
                          <el-input
                            class="textarea-largesize"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入备注"
                            v-model="editData['crm_memo']"/>
                        </el-col>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </el-form>
              </div>
              <div
                class="basic-buttom"
                style="margin-bottom: 20px">
                <el-button
                  type="primary"
                  v-if="canEditManager || canEditSayer || !infoReadOnly || isKaopei || canEditByCreator"
                  :loading="saving"
                  @click="handleSave()">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import student from './student';
import {
  jmChannel,
  jmDictSelect,
} from '@/components/tool';
import { deepClone } from '@/utils/utils';
import _ from 'lodash';
import permissionMixin from './permissionMixin';
import infoMenu from '@/components/infoMenu';
import vueClint from 'vue';

let editData = {
  custom_name: '',
  crm_tel: '',
  crm_weixin: '',
  crm_qq: '',
  custom_hope_country: [], // 意向国家
  // 渠道
  custom_from: '',
  custom_from_sub: '',
  custom_from_thrid: '',
  custom_from_fourth: '',
  custom_from_fifth: '',
  crm_level_lv: 50,
  crm_sayer: -1,
  crm_manager: null,
  crm_sayer_str: '',
  create_person: '',
  create_point: -287,
  custom_promoter: null,
  parent_id: 0,
  activity_id: '',
  bind_name: ''
};

export default {
  mixins: [student, permissionMixin],
  components: {
    jmChannel,
    jmDictSelect,
    infoMenu,
  },
  data() {
    return {
      saving: false,
      countryCheckboxLock: [false, false],
      activeNames: '1',
      channelFinal: false,
      channels: '', // 渠道来源
      activityList: [], // 活动列表
      singapore_explain: [{
        value: '新加坡',
        label: '新加坡'
      }, {
        value: '马来西亚',
        label: '马来西亚',
      }],
      editData: deepClone(editData),
    };
  },
  methods: {
    resetEditData() {
      this.editData = deepClone(editData);
      this.editData.activity_id = parseInt(this.$route.params.acId, 0) ? parseInt(this.$route.params.acId, 0) : '';
      this.channels = {
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: ''
      };
      // 添加
      this.editData.create_person = this.userInfo.userid;
      this.editData.custom_promoter = this.userInfo.userid;
      this.editData.crm_level_lv = 50; // 等待处理
      this.editData.custom_hope_country = (this.teacherCountries.length === 1 && this.teacherCountries[0]) ? this.teacherCountries : [];
      // 新建资源咨询老师赋初值
      if (this.$hasPermission([20, 23, 27, 29, 38, 40, 43, 54, 55, 56, 57, 71, 72, 80, 88, 124, 147, 149], true)) {
        this.editData.crm_sayer = this.userInfo.userid;
      } else {
        this.editData.crm_sayer = -1;
      }
    },
    countryCheckboxClick(val) {
      if (val === 1) {
        vueClint.set(this.countryCheckboxLock, 0, !this.countryCheckboxLock[0]);
      }
    },
    // 保存请求
    saveAjax(student) {
      this.saving = true;
      return new Promise((resolve) => {
        this.$http
          ._post({
            url: '/index/student/save',
            data: student
          })
          .then(({ data, msg }) => {
            this.saving = false;
            this.$message.success(msg || '保存成功');
            this.resetEditData();
            return resolve(data);
          }).catch(() => {
            this.saving = false;
            this.resetEditData();
          });
      });
    },
    /**
       * 保存学生信息
       *
       * @author Cong Peijun <congpeijun@jiemo.net>
       * @param  {Boolean} create 是否为保存并新建
       */
    handleSave() {
      if (!this.hasContactInfo(this.editData.crm_tel, this.editData.crm_weixin)) {
        if (this.userid && !this.hasContactInfo(this.editData.crm_qq)) {
          this.$message.error('请填写联系方式');
          this.$refs.telInput.focus();
          return Promise.reject(new Error('请填写联系方式'));
        }
        if (!this.userid) {
          this.$message.error('必须填写微信或手机号');
          this.$refs.telInput.focus();
          return Promise.reject(new Error('必须填写微信或手机号'));
        }
      }
      if (!this.hasChannel(this.channels)) {
        this.$message.error('渠道来源必须填写');
        this.$refs.channelRef.focus();
        return Promise.reject(new Error('渠道来源必须填写'));
      } else if (!this.channelFinal) {
        this.$message.error('渠道来源必须填写完全');
        return Promise.reject(new Error('渠道来源必须填写完全'));
      }
      if (!this.editData.custom_hope_country || this.editData.custom_hope_country.length < 1) {
        this.$message.error('意向国家必须填写');
        return Promise.reject(new Error('意向国家必须填写'));
      }
      if (this.editData.activity_id === '') {
        this.$message.error('活动必须填写');
        return Promise.reject(new Error('活动必须填写'));
      }

      let student = {
        ...this.editData,
        ...this.channels, // 用户渠道来源
      };
      return this.saveAjax(student);
    },
    initActivityList() {
      this.$http._get({
        url: `/index/general_activity/showActivityListBySiteName/siteName/${this.$siteName}`
      }).then(({ data }) => {
        this.activityList = data;
        this.showActivity = true;
      });
    },

    /**
     * 根据国家过来老师列表
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param {Object} teachers 老师数据
     * @param {Array} teacherIds 允许的老师ID
     * @return {Object}
     */
    filterTeachers(teachers, teacherIds = []) {
      if (!teachers) {
        return teachers;
      }
      let currentTeachers = { ...teachers };
      Object.entries(currentTeachers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          if (t.userid === -1) {
            return true;
          }

          if (teacherIds.length > 0 && teacherIds.indexOf(t.userid) === -1) {
            return false;
          }
          return (
            this.editData.custom_hope_country.indexOf(t.country) > -1 ||
            // 待激活咨询
            t.country === 1808 ||
            // 英美和韩国中心共用老师
            ([-1, -2].indexOf(t.country) !== -1 &&
              _.intersection(this.editData.custom_hope_country, this.countryCode.concat(this.countryCode1)).length) ||
            // 星耀东大老师
            (t.country === -3 &&
              _.intersection(this.editData.custom_hope_country, this.countryCode2).length)
          );
        });
        currentTeachers[char] = teacher;
        if (teacher.length === 0) {
          delete currentTeachers[char];
        }
      });
      return currentTeachers;
    },
  },
  mounted() {
    this.$nextTick(function() {
      this.getDatasource().then((ds) => {
        this.ds.create_point = ds.create_person.ZZ;
        delete this.ds.create_person.ZZ;
        this.resetEditData();
        this.initActivityList();
      });
    });
  },
  computed: {
    /**
       * 获取老师国家，刨除`其他`
       *
       * @author Cong Peijun <congpeijun@jiemo.net>
       * @return {Array}
       */
    teacherCountries() {
      let index = this.userInfo.countries.indexOf(this.countryOther);
      let countries = [...this.userInfo.countries.filter(i => i)];
      if (index > -1) {
        countries.splice(index, 1);
      }
      return countries;
    },
    teachers() {
      return {
        advisory_teacher: this.filterTeachers(this.ds.originAdvisoryTeacher, []),
      };
    },
  },
};
</script>


<style lang="less">
  .basic-information{
    width: 98%;
    margin: 0 auto 18px;
  }
  .webimlink {
    margin-left: 12px;
    padding: 4px 10px;
    background: #409eff;
    color: #fff;
    border-radius: 4px;
  }
  td:nth-child(odd) {
    word-break: keep-all;
  }
  .basic-title {
    height: 35px;
    line-height: 35px;
    margin: 10px 8px 15px;
    position: relative;
    cursor: default;
    border-bottom: 1px solid #b8c4ce;
  }
  .basic-table {
    width: 100%;
  }
  .basic-table th {
    padding: 3px 0;
    background-color: #e2eaf0;
    border-bottom: solid 1px #b8c4ce;
    cursor: pointer;
  }
  .basic-table th span {
    margin-left: 10px;
  }
  .basic-table th i {
    font-size: 14px;
    line-height: 26px;
  }
  .basic-table th i:after {
    display: inline-block;
    margin-left: 10px;
    content: "\e608";
  }
  .basic-table .el-row .el-col {
    display: flex;
    align-items: center;
    min-height: 55px;
    padding-left: 8px;
    border-right: solid 1px #f1f5ff;
    border-bottom: solid 1px #f1f5ff;
    font-size: 12px;
  }
  .basic-table .el-row .el-col-1, .basic-table .el-row .el-col-2{
    justify-content: flex-end;
    padding-right: 5px;
    padding-left: 0;
    font-size: 14px;
    color: #010D2D;
    font-weight: bold;
    text-align: right;
  }
  .basic-table-info .el-row:nth-child(2) .el-col {
    font-weight: bold;
  }
  /*  .basic-table .el-row .el-col:last-child{
      border-right: none;
    }*/
  /*  .basic-table .el-row:last-child .el-col{
      border-bottom: none;
    }*/
  .basic-table .scores-info .el-row .el-col {
    border-right: none;
    border-bottom: none;
    padding-left: 0;
  }
  .basic-table .scores-jmte {
    padding-left: 0 !important;
    border-bottom: none !important;
    border-right: none !important;
  }
  .mindMapping a {
    text-decoration: underline;
    color: #000;
  }
  .jm-span {
    display: inline-block;
    width: 80px;
    text-align: right;
  }
  .basic-buttom {
    margin-top: 25px;
    text-align: center;
  }
  .title-bottom {
    float: right;
    margin: 0 20px;
  }
  .btn-send-msg {
    cursor: pointer;
  }
  .jm-studentEditBot {
    display: block;
    height: 100%;
    opacity: 1;
    margin-top: 3px;
  }
  .jm-tbody-hidden {
    display: none;
  }
  .diff_column input.el-input__inner {
    border-color: red;
  }
  .diff_column .el-select input.el-input__inner {
    border-color: red;
  }
  .basic-table-div .el-form-item__content {
    line-height: inherit !important;
    font-size: 12px;
  }
  // .extraRow, .extraRow div{
  //   /*height: 100px;*/
  // }

  .input_class {
    width: 150px;
  }
  .hope_country{
    display: flex;
    justify-content: flex-start;
  }
  .hope_country>div:nth-of-type(1){
    width: 4.16667%;
  }
  .hope_country>div:nth-of-type(2){
    width: 95.83333%;
  }
  .colour{
    color: #F75694;
  }
  .bind {
    display: inline-block;
    width: auto !important;
    float: left;
    height: 31px;
    font-size: 16px;
    line-height: 28px;
    padding: 0 8px;
    border-bottom: 4px solid #3368fa;
    margin-left: 10px;
    margin-bottom: 10px;
  }
</style>
